import { StrictMode, lazy, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { logStartupMilestone } from './diagnostics/startupTrace';
import './styles/theme.css';
import { isMobileDevice } from './mobile/device';
import { isMetaSharePage, requestShareBrowserHandoff } from './services/shares/externalBrowser';
const App = lazy(() => import('./app/App').then(module => ({ default: module.App })));
const SharePage = lazy(() => import('./app/SharePage').then(module => ({ default: module.SharePage })));
const publicShare = /^\/share\/[A-Za-z0-9_-]{8,128}\/?$/.test(location.pathname);
const metaShareGateway = publicShare && isMetaSharePage(new URL(location.href), navigator.userAgent);
if (metaShareGateway) requestShareBrowserHandoff();
if (!publicShare && !isMobileDevice()) void import('dockview-react/dist/styles/dockview.css');

const container = document.getElementById('root');
if (!container) throw new Error('#root element missing in index.html');
logStartupMilestone('app start');
createRoot(container).render(
  <StrictMode>
    <Suspense fallback={<main className="share-load-screen" role="status">Loading…</main>}>
      {metaShareGateway ? (
        <main className="share-load-screen" role="status">
          <p>Opening your browser…</p>
          <p>If this page stays open, use the Facebook or Messenger menu to open this link in your browser.</p>
        </main>
      ) : publicShare ? <SharePage /> : <App />}
    </Suspense>
  </StrictMode>,
);

// Stage 03 is explicitly opt-in and remains outside the ordinary render path.
if (new URLSearchParams(location.search).get('hp') === '1') {
  void import('./precision/hpDiagnostics').then(module => module.installHpDiagnostics());
}
